import React from 'react'
import PropTypes from 'prop-types'

import { Heading } from './system'
import { Container } from './containers'
import { TitleLink, NavItem } from './navigation'

const Header = ({ siteTitle }) => {
  return (
    <Container py={{ xxs: 4, sm: 6 }}>
      <Heading m={0} fontSize={3}>
        <TitleLink to="/">{siteTitle}</TitleLink>
      </Heading>
      <nav>
        <NavItem to="/color/">Color</NavItem>
        <NavItem to="/logo/">Logo</NavItem>
        <NavItem to="/typography/">Typography</NavItem>
      </nav>
    </Container>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
